import styled from 'styled-components';

export const SVehicleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(max(150px, calc(50% - 8px)), 100%), 1fr));
  gap: 8px;
`;
